import type ProductsCard from "@travily/types/models/ProductsCard";
import type {
  ProductsCardPhotosTrait,
  ProductsCardPricingTrait,
  ProductsCardReviewsTrait,
} from "@travily/types/models/ProductsCard";
import type ServicesCard from "@travily/types/models/ServicesCard";
import type {
  ServicesCardPhotosTrait,
  ServicesCardPricingTrait,
  ServicesCardReviewsTrait,
} from "@travily/types/models/ServicesCard";
import { CardGrid } from "@ui/components/CardGrid";
import { EmptyState } from "@ui/components/EmptyState";
import { Illustration } from "@ui/components/Illustration";
import { ListingCardAdapter } from "@/components/ListingCard/ListingCardAdapter";

type FavoriteProduct = ProductsCard & ProductsCardPhotosTrait & ProductsCardPricingTrait & ProductsCardReviewsTrait;
type FavoriteService = ServicesCard & ServicesCardPhotosTrait & ServicesCardPricingTrait & ServicesCardReviewsTrait;

export interface MarketplaceFavoritesProps {
  empty: { description: string; title: string };
  getFavorited?: (type: string, id: string | number) => boolean;
  products: FavoriteProduct[];
  services: FavoriteService[];
  onFavoriteToggle?: (favorableType: string, favorableId: string | number) => void;
}

export function MarketplaceFavorites({
  empty,
  getFavorited,
  products,
  services,
  onFavoriteToggle,
}: MarketplaceFavoritesProps) {
  if (products.length === 0 && services.length === 0) {
    return (
      <EmptyState description={empty.description} illustration={<Illustration name="products" />} title={empty.title} />
    );
  }

  return (
    <CardGrid>
      {products.map((product) => (
        <ListingCardAdapter
          favorited={getFavorited ? getFavorited("Listing", product.sqid) : true}
          key={product.sqid}
          onFavoriteToggle={onFavoriteToggle ? () => onFavoriteToggle("Listing", product.sqid) : undefined}
          listing={product}
        />
      ))}
      {services.map((service) => (
        <ListingCardAdapter
          favorited={getFavorited ? getFavorited("Listing", service.sqid) : true}
          key={service.sqid}
          onFavoriteToggle={onFavoriteToggle ? () => onFavoriteToggle("Listing", service.sqid) : undefined}
          listing={service}
        />
      ))}
    </CardGrid>
  );
}
